var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConfigv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_12827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8672 15.0196C8.86467 14.6636 9.14417 14.381 9.49713 14.3818C9.84671 14.3818 10.138 14.6753 10.1338 15.0212C10.1296 15.3463 9.84249 15.6364 9.51148 15.6481C9.17119 15.6606 8.86974 15.3672 8.8672 15.0204V15.0196Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31546 0.584961L8.13092 3.40416C7.89401 3.47524 7.6808 3.59369 7.46758 3.71214L4.64838 2.5276L2.94264 4.23334L4.12718 7.05254C4.00873 7.28945 3.91396 7.47898 3.8192 7.71588L1 8.90042V11.2695L3.8192 12.454C3.91396 12.6909 4.00873 12.8805 4.12718 13.1174L2.94264 15.9366L4.64838 17.6423L7.46758 16.4578C7.6808 16.5525 7.89401 16.671 8.13092 16.7658L9.31546 19.585H11.6845L12.8691 16.7658C13.0823 16.671 13.3192 16.5762 13.5324 16.4578L16.3516 17.6423L18.0574 15.9366L16.8728 13.1174C16.9676 12.9042 17.086 12.6673 17.1808 12.454L20 11.2695V8.90042L17.1808 7.71588C17.1097 7.50267 16.9913 7.26576 16.8728 7.05254L18.0574 4.23334L16.3516 2.5276L13.5324 3.71214C13.3192 3.61738 13.0823 3.49893 12.8691 3.40416L11.6845 0.584961L9.31546 0.584961ZM10.5 6.50765C12.4663 6.50765 14.0536 8.09494 14.0536 10.0613C14.0536 12.0276 12.4663 13.6149 10.5 13.6149C8.53367 13.6149 6.94638 12.0276 6.94638 10.0613C6.94638 8.09494 8.53367 6.50765 10.5 6.50765Z",
    fill: "#656565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_12827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.248047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfigv2);
export default __webpack_public_path__ + "static/media/icon-configv2.4bc9b94fadc4dcf116ffc23a4732d8f3.svg";
export { ForwardRef as ReactComponent };